import { Injectable } from '@angular/core';
import { signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public _isDarkMode = signal(true);
  public isDarkMode(): boolean {
    return this._isDarkMode();
  }

  public toggleDarkMode(): void {
    this._isDarkMode.update((val) => !val);
  }
}
